import us from "./default.us_en.json"
import jp from "./default.ja.json"
import es from "./default.esp_es.json"
import fr from "./default.fr.json"
import it from "./default.it.json"
import mx from "./default.mex.json"
import oe from "./default.eu_en.json"
import de from "./default.de.json"
import uk from "./default.gb_en.json"
import au from "./default.aus_en.json"
import ca from "./default.ca_en.json"
import ko from "./default.kr.json"

export {
    us, jp, es, fr, it, mx, oe, de, uk, au, ca, ko
};
